import BaseService from './BaseService'
import { IBrand } from '../interfaces/brand'

const defaultUploadId = process.env.REACT_APP_DEFAULT_UPLOAD_ID

class BrandService extends BaseService {
  constructor() {
    super('brand')
  }

  fetchAvailable(locationId: string, page: number, limit: number): Promise<IBrand[]> {
    const formData = new FormData()
    formData.append('location_id', locationId)
    formData.append('page', `${page}`)
    formData.append('limit', `${limit}`)

    if(page < 1) {
      return this.fetchAllAvailable(locationId)
    }

    return new Promise((resolve, reject) => {
      const cacheKey = `brands_available_${locationId}_${page}_${limit}`
      const cachedData = this.cache.get(cacheKey)
      if (cachedData) {
        resolve(cachedData)
      } else {
        try {
          this.http
            .post(`brand/read_available`, formData)
            .then((data: any) => {
              if (data.code === 200) {
                this.cache.set(cacheKey, data.data)
                resolve(data.data)
              } else reject({ message: data.message })
            })
        } catch (error) {
          reject({ message: 'An unexpected error occured!' })
          throw error
        }
      }
    })
  }

  fetchAllAvailable(locationId: string): Promise<IBrand[]> {
    const formData = new FormData()
    formData.append('location_id', locationId)
    formData.append('page', '0')
    formData.append('limit', '0')

    return new Promise((resolve, reject) => {
      const cacheKey = `brands_available_${locationId}`
      const cachedData = this.cache.get(cacheKey)
      if (cachedData && false) {
        resolve(cachedData)
      } else {
        try {
          this.http
            .post(`brand/read_available`, formData)
            .then((data: any) => {
              if (data.code === 200) {
                this.cache.set(cacheKey, data.data)
                resolve(data.data)
              } else reject({ message: data.message })
            })
        } catch (error) {
          reject({ message: 'An unexpected error occured!' })
          throw error
        }
      }
    })
  }

  fetchByManufacturer(mftrId: string): Promise<IBrand[]> {
    const formData = new FormData()
    formData.append('manufacturer_id', mftrId)

    return new Promise((resolve, reject) => {
      const cacheKey = `brands_${mftrId}`
      const cachedData = this.cache.get(cacheKey)
      if (cachedData) {
        resolve(cachedData)
      } else {
        try {
          this.http
            .post(`brand/read_by_manufacturer`, formData)
            .then((data: any) => {
              if (data.code === 200) {
                this.cache.set(cacheKey, data.data)
                resolve(data.data)
              } else reject({ message: data.message })
            })
        } catch (error) {
          reject({ message: 'An unexpected error occured!' })
          throw error
        }
      }
    })
  }

  create(brand: IBrand): Promise<any> {
    delete brand.manufacturer // not needed for api call

    const formData = new FormData()
    formData.append('upload_id', defaultUploadId) // default

    Object.keys(brand).forEach((key) => {
      formData.append(key, brand[key])
    })

    return new Promise((resolve, reject) => {
      try {
        this.http.post('brand/create', formData).then((data: any) => {
          if (data.code === 200) {
            this.cache.reset()
            resolve(data.data)
          } else reject({ message: data.message })
        })
      } catch (error) {
        reject({ message: 'An unexpected error occured!' })
        throw error
      }
    })
  }

  update(brand: IBrand): Promise<any> {
    delete brand.manufacturer // not needed for api call

    const formData = new FormData()

    Object.keys(brand).forEach((key) => {
      formData.append(key, brand[key])
    })

    return new Promise((resolve, reject) => {
      try {
        this.http.post('brand/update', formData).then((data: any) => {
          if (data.code === 200) {
            this.cache.reset()
            resolve(data.data)
          } else reject({ message: data.message })
        })
      } catch (error) {
        reject({ message: 'An unexpected error occured!' })
        throw error
      }
    })
  }
}

export default BrandService
